import { apiReducer } from "@utils/reduxUtil";
import { MODULE_NAME } from "../constants";
import { DashboardInitialStateInterface } from "../types";

const initialState: DashboardInitialStateInterface = {
	fetchTransactionsSummary: null,
	fetchTransactionsSummaryStart: false,
};

const dashboardReducer = (state = initialState, action: any): DashboardInitialStateInterface => {
	return (state = apiReducer(state, action, MODULE_NAME));
};

export default dashboardReducer;
